import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../../styles/SubscriptionContainer.module.scss';
import { usePurchaseSubscriptionContext } from '../../../PurchaseSubscription/context/PurchaseSubscriptionContext';
import AppPaths from '../../../../AppPaths';
import { useHistory, useLocation } from 'react-router-dom';
import SubscriptionAppBar from '../../components/SubscriptionAppBar';

import ValuePropsBox from '../../../ProductDetails/Series3CollarDetails/components/ValuePropsBox/ValuePropsBox';
import { getWhatsNewValueProps } from '../../../ProductDetails/Series3CollarDetails/components/ValuePropsBox/WhatsNewValueProps';
import Button from '../../../../components/Button/Button';
import * as gqlTypes from '../../../../types/gql-op-types';
import { inAppCancellation as events } from '../../../../lib/analytics/events';
import yellowS3CollarImg from '../../../../assets/images/in_app_cancellation/s3_yellow_flat.png';
import { BaseInAppCancellationState } from '../util/types';
import ErrorScreen from '../../components/ErrorScreen/ErrorScreen';

export interface UpgradeSeries2State extends BaseInAppCancellationState {
  selectedCancelReason: gqlTypes.zendeskCancellationReason;
}

export default function UpgradeSeries2() {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation<UpgradeSeries2State>();
  const { selectedCancelReason, subscriptionCategory } = location.state;
  const { device } = usePurchaseSubscriptionContext();
  const petName = device.pet?.name ?? t('your_dog');
  const petId = device.pet!.id;
  events.pageLoad(
    { petId, cancellationReason: selectedCancelReason, subscriptionCategory },
    'Upgrade Your Series 2 Collar',
  );

  if (!device.subscription?.id) {
    return <ErrorScreen />;
  }

  const handleCancel = () => {
    if (!device.subscription?.id) {
      throw new Error('No recurly subscription found.');
    }

    events.upgradeS2Cancel({ petId, cancellationReason: selectedCancelReason, subscriptionCategory });

    history.push({
      pathname: AppPaths.Subscription.FreeMonthOffer(device.moduleId),
      state: { selectedCancelReason, subscriptionCategory },
      search: window.location.search,
    });
  };

  return (
    <>
      <div className={styles.fullWidthWrapper}>
        <SubscriptionAppBar
          backButtonAnalyticsEvent={() => events.upgradeS2Back({ petId: device.pet?.id, subscriptionCategory })}
          closeButtonAnalyticsEvent={() => events.upgradeS2Close({ petId: device.pet?.id, subscriptionCategory })}
        />
        <div className={styles.subscriptionContainer}>
          <h1>{t('upgrade_your_series_2_collar_get_credit_for_a_series_3')}</h1>
          <p>
            {t(
              'our_fi_series_3_collar_is_our_smartest_smallest_and_most_resilient_collar_yet_it_could_be_just_what_pet_name_needs',
              {
                petName,
              },
            )}
          </p>
        </div>

        <img className={styles.collarAvatar} src={yellowS3CollarImg} alt={t('yellow_collar_flat')} />
        <div className={styles.whatsNew}>
          <h2>{t('whats_new')}</h2>
          <ValuePropsBox valueProps={getWhatsNewValueProps(t)} />
        </div>
        <div className={styles.buttonContainer}>
          <Button
            className={styles.button}
            onClick={() => {
              events.series2UpgradePageUpgradeClicked({ petId: petId, subscriptionCategory });
              history.push(AppPaths.Series3Upgrade.SplashPageForPet(petId));
            }}
          >
            {t('upgrade_now')}
          </Button>
          <Button onClick={handleCancel} className={styles.button} tertiary={true}>
            {t('no_cancel')}
          </Button>
        </div>
      </div>
    </>
  );
}
